import React, { useEffect, useState, useRef } from "react";

export const StatisticsSection = () => {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
    { value: 1000, suffix: "+", label: "Elite Professionals Indexed" },
    { value: 10, suffix: "+", label: "Sovereign Countries Served" },
    { value: 24, suffix: "/7", label: "Global Operations Dispatch" },
    { value: 99.99, suffix: "%", label: "Mission Critical Focus Assured" }
  ];

  // Increment counter hook simulation
  const [counts, setCounts] = useState([0, 0, 0, 0]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!inView) return;

    let startTime = null;
    const duration = 1800; // ms

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      const newCounts = stats.map((s) => {
        // Linear easeOut calculation
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const currentVal = easedProgress * s.value;
        return s.value % 1 === 0 ? Math.floor(currentVal) : parseFloat(currentVal.toFixed(2));
      });

      setCounts(newCounts);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCounts(stats.map((s) => s.value));
      }
    };

    requestAnimationFrame(animate);
  }, [inView]);

  return (
    <section 
      ref={sectionRef} 
      data-testid="statistics-section"
      className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-14 md:pb-16"
    >
      <div className="glass-panel rounded-3xl p-8 md:p-12 border border-white/10 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 relative overflow-hidden bg-black/40">
        {/* Subtle moving spotlight background inside panel */}
        <div className="absolute inset-0 bg-gradient-to-tr from-emerald-500/5 via-transparent to-transparent pointer-events-none"></div>

        {stats.map((stat, idx) => (
          <div 
            key={idx}
            data-testid={`stat-card-${idx}`}
            className="flex flex-col items-start gap-1 relative z-10"
          >
            <div className="flex items-baseline font-mono">
              <span 
                data-testid={`stat-count-${idx}`}
                className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white drop-shadow-[0_0_15px_rgba(101,255,182,0.3)]"
              >
                {counts[idx]}
              </span>
              <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#65FFB6]">
                {stat.suffix}
              </span>
            </div>
            <p className="text-xs sm:text-sm font-manrope text-slate-400 font-medium uppercase tracking-wider max-w-[180px] mt-1">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};
